<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 600px; height: 500px;" data-cy="appointment-detail-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="appointment-detail-header-section">
      <div class="section-header-title" data-cy="appointment-detail-title-text">
        Appointment Details
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; overflow: hidden;" data-cy="appointment-detail-content-section">
      <div style="width: 100%; height: 100%; overflow-y: auto;" data-cy="appointment-detail-scrollable-container">
        <div style="display: flex; width: 100%;" data-cy="appointment-detail-subject-row">
          <div style="flex-basis: 140px; text-align: right; margin-right: 8px; font-weight: 500;" data-cy="appointment-detail-subject-label">Subject:</div>
          <div style="flex: 1;" data-cy="appointment-detail-subject-value">{{data.Subject}}</div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 8px;" data-cy="appointment-detail-note-row">
          <div style="flex-basis: 140px; text-align: right; margin-right: 8px; font-weight: 500;" data-cy="appointment-detail-note-label">Note:</div>
          <div style="flex: 1;" data-cy="appointment-detail-note-value">{{data.Description}}</div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 8px;" data-cy="appointment-detail-referring-doctor-row">
          <div style="flex-basis: 140px; text-align: right; margin-right: 8px; font-weight: 500;" data-cy="appointment-detail-referring-doctor-label">Referring Doctor:</div>
          <div style="flex: 1;" data-cy="appointment-detail-referring-doctor-value">{{getReferringDoctor()}}</div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 8px;" data-cy="appointment-detail-procedure-row">
          <div style="flex-basis: 140px; text-align: right; margin-right: 8px; font-weight: 500;" data-cy="appointment-detail-procedure-label">Procedure:</div>
          <div style="flex: 1;" data-cy="appointment-detail-procedure-value">{{data.Procedure.ProcedureName}}</div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 8px;" data-cy="appointment-detail-provider-row">
          <div style="flex-basis: 140px; text-align: right; margin-right: 8px; font-weight: 500;" data-cy="appointment-detail-provider-label">Provider Doctor:</div>
          <div style="flex: 1;" data-cy="appointment-detail-provider-value">{{getDoctor()}}</div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 8px;" data-cy="appointment-detail-datetime-row">
          <div style="flex-basis: 140px; text-align: right; margin-right: 8px; font-weight: 500;" data-cy="appointment-detail-datetime-label">Date and Time</div>
          <div style="flex: 1;" data-cy="appointment-detail-datetime-value">Start {{data.StartDate | date: 'short'}} -  End {{data.EndDate | date: 'short'}}</div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 8px;" data-cy="appointment-detail-type-row">
          <div style="flex-basis: 140px; text-align: right; margin-right: 8px; font-weight: 500;" data-cy="appointment-detail-type-label">Type</div>
          <div style="flex: 1;" data-cy="appointment-detail-type-value">{{getType()}}</div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 8px;" data-cy="appointment-detail-status-row">
          <div style="flex-basis: 140px; text-align: right; margin-right: 8px; font-weight: 500;" data-cy="appointment-detail-status-label">Status</div>
          <div style="flex: 1;" data-cy="appointment-detail-status-value">{{getStatus()}}</div>
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="appointment-detail-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="appointment-detail-ok-button">Ok</button>
    </div>
  </div>
</div>
